module.exports = __webpack_public_path__ + "5053f4e3d3ae9aceb8ebbc755a7314cd.pdf";